import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ValidationErrorsComponent } from "./components/validation-errors.component";
import { ValidationErrorBodyPipe } from "./pipes/validation-error-body.pipe";
import { TranslateModule } from "@ngx-translate/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { LogValidationErrorInterceptor } from "./helpers/log-validation-error.interceptor";
import { TelenetIconModule } from "@shared/telenet-icons";

@NgModule({
   exports: [ValidationErrorsComponent, ValidationErrorBodyPipe],
   imports: [
      CommonModule,
      TranslateModule,
      TelenetIconModule,
      ValidationErrorsComponent,
      ValidationErrorBodyPipe
   ],
   providers: [
      {
         provide: HTTP_INTERCEPTORS,
         useClass: LogValidationErrorInterceptor,
         multi: true
      }
   ]
})
export class ValidationErrorsModule {}
